import { useEffect, useState } from 'react'

export const useSideBySideSupport = () => {
	const [windowWidth, setWindowWidth] = useState(
		typeof window !== 'undefined' ? window.innerWidth : 0,
	)

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth)
		}

		if (typeof window !== 'undefined') {
			window.addEventListener('resize', handleResize)
			return () => window.removeEventListener('resize', handleResize)
		}
	}, [])

	// If we're inside an iframe (meaning we're in the view-side-by-side page), always return true
	if (typeof window !== 'undefined' && window.frameElement !== null) {
		return true
	}

	return windowWidth > 1129
}
